import styled from 'styled-components';
import Image from '../Image';

interface BackgroundType extends React.ComponentProps<typeof Image> {
  background?: string;
}

export const BackgroundImage = styled(Image)<BackgroundType>`
  display: block;
  background-size: cover;
  overflow: auto;

  ${({ background }) => (background ? `--background-base: ${background};` : '')}
  /* stylelint-disable-next-line declaration-block-no-shorthand-property-overrides */
  background: var(--background-base, inherit);
`;

export const Background = styled.section<{ background?: string }>`
  overflow: auto;

  ${({ background }) => (background ? `--background-base: ${background};` : '')}
  /* stylelint-disable-next-line declaration-block-no-shorthand-property-overrides */
  background: var(--background-base, inherit);
`;

type ContentPropTypes = {
  color?: string;
  accentColor?: string;
  textAlign?: React.CSSProperties['textAlign'];
  disablePaddings?: {
    before?: boolean;
    after?: boolean;
    start?: boolean;
    end?: boolean;
  };
  disableMaxWidth?: boolean;
};
export const Content = styled.article<ContentPropTypes>`
  margin: 0 auto;
  max-width: 100%;
  box-sizing: border-box;

  ${({ textAlign }) => textAlign && `text-align: ${textAlign}`};

  ${({ color }) => color && `--text-base: ${color};`};
  ${({ accentColor }) =>
    accentColor && `--text-bright-accent: ${accentColor};`};

  color: var(--text-base, inherit);
  strong {
    color: var(--text-bright-accent, inherit);
  }

  ${({ disablePaddings }) => !disablePaddings?.start && `padding-top: 35px;`};
  ${({ disablePaddings }) => !disablePaddings?.before && `padding-left: 15px;`};
  ${({ disablePaddings }) => !disablePaddings?.end && `padding-bottom: 35px;`};
  ${({ disablePaddings }) => !disablePaddings?.after && `padding-right: 15px;`};
  @supports (padding: max(0px)) {
    ${({ disablePaddings }) =>
      !disablePaddings?.start &&
      `
        --container-padding-start: max(35px, env(safe-area-inset-top));
        padding-top: var(--container-padding-start);
      `};
    ${({ disablePaddings }) =>
      !disablePaddings?.before &&
      `
        --container-padding-before: max(15px, env(safe-area-inset-left));
        padding-left: var(--container-padding-before);
      `};
    ${({ disablePaddings }) =>
      !disablePaddings?.end &&
      `
        --container-padding-end: max(35px, env(safe-area-inset-bottom));
        padding-bottom: var(--container-padding-end);
      `};
    ${({ disablePaddings }) =>
      !disablePaddings?.after &&
      `
        --container-padding-after: max(15px, env(safe-area-inset-right));
        padding-right: var(--container-padding-after);
      `};
  }

  @media (min-width: 768px) {
    ${({ disableMaxWidth }) => !disableMaxWidth && `width: 750px;`};

    ${({ disablePaddings }) => !disablePaddings?.start && `padding-top: 75px;`};
    ${({ disablePaddings }) =>
      !disablePaddings?.before && `padding-left: 15px;`};
    ${({ disablePaddings }) =>
      !disablePaddings?.end && `padding-bottom: 75px;`};
    ${({ disablePaddings }) =>
      !disablePaddings?.after && `padding-right: 15px;`};

    @supports (padding: max(0px)) {
      ${({ disablePaddings }) =>
        !disablePaddings?.start &&
        `padding-top: max(75px, env(safe-area-inset-top));`};
      ${({ disablePaddings }) =>
        !disablePaddings?.before &&
        `padding-left: max(15px, env(safe-area-inset-left));`};
      ${({ disablePaddings }) =>
        !disablePaddings?.end &&
        `padding-bottom: max(75px, env(safe-area-inset-bottom));`};
      ${({ disablePaddings }) =>
        !disablePaddings?.after &&
        `padding-right: max(15px, env(safe-area-inset-right));`};
    }
  }

  @media (min-width: 992px) {
    ${({ disableMaxWidth }) => !disableMaxWidth && `width: 970px;`};
  }

  @media (min-width: 1200px) {
    ${({ disableMaxWidth }) => !disableMaxWidth && `width: 1170px;`};
  }
`;
